import { useQuery } from '@tanstack/react-query'
import { buildQuery, useApi } from './client'
import type { CashflowResponse } from './types'

export type CashflowFilters = {
  organizationId?: string | null
  accountIds?: string[]
  projectIds?: string[]
  tagIds?: string[]
  dateFrom: string
  dateTo: string
  groupBy?: 'category' | 'project'
  period?: 'month' | 'quarter' | 'year'
  currencyMode?: 'base' | 'native'
}

function filtersKey(f: CashflowFilters) {
  return {
    organizationId: f.organizationId ?? null,
    accountIds: [...(f.accountIds ?? [])].sort(),
    projectIds: [...(f.projectIds ?? [])].sort(),
    tagIds: [...(f.tagIds ?? [])].sort(),
    dateFrom: f.dateFrom,
    dateTo: f.dateTo,
    groupBy: f.groupBy ?? 'category',
    period: f.period ?? 'month',
    currencyMode: f.currencyMode ?? 'base',
  }
}

export function useCashflow(filters: CashflowFilters, opts?: { enabled?: boolean }) {
  const api = useApi()
  const key = filtersKey(filters)
  return useQuery({
    queryKey: ['reports', 'cashflow', key],
    enabled: opts?.enabled ?? true,
    queryFn: () => {
      const query = buildQuery({
        organization_id: filters.organizationId ?? undefined,
        date_from: filters.dateFrom,
        date_to: filters.dateTo,
        group_by: key.groupBy,
        period: key.period,
        currency_mode: key.currencyMode,
        account_id: key.accountIds,
        project_id: key.projectIds,
        tag_id: key.tagIds,
      })
      return api<CashflowResponse>(`/reports/cashflow${query}`)
    },
  })
}
